/**
 * Record API failures into the bug-report capture buffer (when enabled).
 */

import { shouldCaptureApiErrors } from './captureConfig'
import { captureBufferPushApiError } from './captureBuffer'

export function maybeCaptureApiError(endpoint: string, error: unknown): void {
  if (!shouldCaptureApiErrors()) return
  try {
    captureBufferPushApiError(endpoint, error)
  } catch {
    /* ignore */
  }
}
